import { useEffect, useState } from 'react';
import { getUserChoice, isDark, onThemeChange, setUserChoice, type ThemeChoice } from '../lib/theme';

/**
 * Selector de tema. El botón del medio ya NO selecciona "según el sistema"
 * -- alterna directamente entre claro y oscuro según lo que se ve ahora
 * mismo (pedido explícito: que con solo apretar el botón del medio cambie
 * de día a noche). Sol/luna en los extremos siguen fijando el tema
 * explícito de cada lado, sin cambios. 'system' sigue existiendo como
 * concepto interno (predeterminado institucional cuando la persona nunca
 * eligió nada, ver lib/theme.ts), solo dejó de ser una opción elegible
 * desde este control.
 */
export function ThemeToggle() {
  const [choice, setChoice] = useState<ThemeChoice | null>(getUserChoice());
  const [dark, setDark] = useState(isDark());

  useEffect(
    () =>
      onThemeChange(() => {
        setChoice(getUserChoice());
        setDark(isDark());
      }),
    [],
  );

  return (
    <div className="theme-seg" role="group" aria-label="Tema de la interfaz">
      <button
        type="button"
        title="Tema claro"
        aria-label="Tema claro"
        aria-pressed={choice === 'light'}
        onClick={() => setUserChoice('light')}
      >
        ☀
      </button>
      <button
        type="button"
        title={dark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
        aria-label={dark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
        onClick={() => setUserChoice(dark ? 'light' : 'dark')}
      >
        ◐
      </button>
      <button
        type="button"
        title="Tema oscuro"
        aria-label="Tema oscuro"
        aria-pressed={choice === 'dark'}
        onClick={() => setUserChoice('dark')}
      >
        ☾
      </button>
    </div>
  );
}
